import { render, staticRenderFns } from "./modal_add_medsos_chart.vue?vue&type=template&id=56eb27ba&scoped=true"
import script from "./modal_add_medsos_chart.vue?vue&type=script&lang=js"
export * from "./modal_add_medsos_chart.vue?vue&type=script&lang=js"
import style0 from "./modal_add_medsos_chart.vue?vue&type=style&index=0&id=56eb27ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb27ba",
  null
  
)

export default component.exports